import { useState } from 'react';
import classNames from 'classnames';
import PlainButton from '@components/UI/PlainButton';
import WhyWeAskModal from '@scenes/HomeHub/components/WhyWeAsk/WhyWeAsk.Modal';
import { useHomeHubQuestionSelector } from '@scenes/HomeHub/store/queries/useHomeHub.selectors';
import styles from '../components.module.scss';

const WhyWeAsk = () => {
  /* Local State */
  const [showModal, setShowModal] = useState(false);

  /* Query Selector */
  const currentQuestion = useHomeHubQuestionSelector();

  /* If no whyWeAsk data, leave */
  if (!currentQuestion?.info) return null;

  return (
    <div className={classNames(styles.whyWeAsk, 'paddingTop-medium1 paddingBottom-medium1')}>
      <PlainButton onClickHandler={() => setShowModal(true)}>Why we ask</PlainButton>
      <WhyWeAskModal info={currentQuestion.info} isVisible={showModal} hide={() => setShowModal(false)} />
    </div>
  );
};

export default WhyWeAsk;
